import React from "react";
import profilePic from "../assets/images/max.png";

const About: React.FC = () => {
  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
      <div className="w-full lg:flex-1 lg:max-w-[825px]">
        <h2 className="font-sans text-2xl sm:text-4xl font-medium">
          Hey, I'm Max!
        </h2>
        <p className="mt-4 font-sans text-4xl sm:text-6xl lg:text-8xl font-bold">
            Innovating at <br />
            the intersection <br />
            of technology <br />
            and design
        </p>
      </div>
      <div className="w-full lg:w-auto flex justify-center lg:justify-end">
        <img
          src={profilePic}
          alt="Profile"
          className="w-48 sm:w-56 lg:w-72 aspect-square rounded-full object-cover"
        />
      </div>
    </div>
  );
};

export default About;
